// Book grab tilt: drag offset (px from the press point) → rigid book tilt in degrees.
export const MAX_TILT = 25;
export const DEG_PER_PX = 0.25;

const clamp = (v: number, m: number) => Math.max(-m, Math.min(m, v));

export function tiltFor(dx: number, dy: number): { rx: number; ry: number } {
  // `+ 0` normalises -0 so a level book reads as exactly 0.
  return { rx: clamp(-dy * DEG_PER_PX, MAX_TILT) + 0, ry: clamp(dx * DEG_PER_PX, MAX_TILT) + 0 };
}
